/**
 * URL encode a locator.
 */
export default function nuc(comp: string, maxDepth: number = 2) {
  if (!comp) {
    return '';
  }
  const originalStr = `${comp}`;
  let prev = null;
  let cur = originalStr;

  let innerMaxDepth = maxDepth;

  /**
   * The purpose of this loop is to handle the case where the string has been URI encoded multiple times.
   * It will try and decode the string until either:
   * 1. The decoded string is the same as the previous string (which means decoding did nothing)
   * 2. A `+` character is found (which means we've fully decoded a locator string)
   * 3. We've reached the maximum depth and won't attempt to decode any more.
   *
   * This function is apparently primarily meant for encoding **Locator** strings, even though we use it for much more.
   */
  while (prev !== cur && !cur.includes('+') && innerMaxDepth-- > 0) {
    prev = cur;
    try {
      cur = decodeURIComponent(cur);
    } catch (e) {
      // If the string is not valid URI encoded, return the encoded version of the string.
      // For example, if the string is not URI encoded and contains a plaintext `%`, we don't want to fail but we do
      // want to return the encoded version of the string.
      return encodeURIComponent(cur);
    }
  }
  return encodeURIComponent(cur);
}
